module.exports = __webpack_public_path__ + "static/media/hushdream-logo.ad2ad574.png";